import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Themes from '../Themes';
import translations from '../../translations';

function PreviewTentative() {
  const { theme } = useParams();
  const Components = Themes[theme];
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'en');
  const t = translations[language];

  const heroStyle = {
    backgroundImage: `url(${Components.bg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  };

  const startTime = "11:00";
  const endTime = "14:00";

  function convertTo12HourFormat(time24) {
    const [hours, minutes] = time24.split(":");
    const period = hours >= 12 ? "pm" : "am";
    const hours12 = hours % 12 || 12; // Convert 0 to 12 for midnight
  
    return `${hours12}:${minutes} ${period}`;
  }

  function addMinutesToTime(timeString, minutesToAdd) {
    const [hours, minutes] = timeString.split(':').map(Number);
  
    // Convert everything to minutes
    const totalMinutes = hours * 60 + minutes;
    const newTotalMinutes = totalMinutes + minutesToAdd;
  
    // Calculate new hours and minutes
    const newHours = Math.floor(newTotalMinutes / 60);
    const newMinutes = newTotalMinutes % 60;
  
    // Format the result
    const formattedTime = `${newHours.toString().padStart(2, '0')}:${newMinutes.toString().padStart(2, '0')}`;
  
    return formattedTime;
  }

  const tetamuHadir = addMinutesToTime(startTime, 0);
  const tibaPengantin = addMinutesToTime(tetamuHadir, 90);

  const tetamuHadirNew = convertTo12HourFormat(tetamuHadir);
  const tibaPengantinNew = convertTo12HourFormat(tibaPengantin);
  const endTimeNew = convertTo12HourFormat(endTime);

  const defaultData = [
    { title: "Wedding Ceremony", displaytime: tetamuHadirNew, time:tetamuHadir},
    { title: "Lunch Reception", displaytime: tibaPengantinNew, time:tibaPengantin},
    { title: "End", displaytime: endTimeNew, time:endTime},
  ];

  const aturCaraMajlis = defaultData;

  const fontP = Components.fontP;

  return (
    <div className="min-h-screen relative flex items-center justify-center overflow-hidden" style={heroStyle}>
      <div className="text-center z-10 my-20">
        <div className={Components.tStyle}>
        {/* <div className={Components.tStyle}> */}
          <h1 className={`text-l mb-8 uppercase font-bold ${fontP}`}>{t.schedule}</h1>
          {aturCaraMajlis.map((item, index) => (
            <div key={index} className={`my-4 ${fontP}`}>
              <p className="text-l">{item.title}:</p>
              <p className="text-l">{item.displaytime}</p>
            </div>
          ))}
        </div>
      </div>
      <img
        src={Components.ft}
        
        className={Components.ftStyle}
      />
      <img
        src={Components.fb}
        
        className={Components.fbStyle}
      />
    </div>
  );
}

export default PreviewTentative;
